import React from 'react';
import ArabToLatinModule from './ArabToLatinModule.js'
import Article from './Article.js'
import LessonHandler from '../LessonHandler.js'

const lessonHandler = new LessonHandler()
const lessons = lessonHandler.getLessons()

class LessonIndex extends React.Component {
  state = { lesson: null, done: false }
  setLesson(newLesson) {
    this.setState({lesson: newLesson})
  }
  render() {

    if (this.state.lesson === null) {
      return (<div>
        {lessons.map(item => {
          return (<LessonButton setLesson={this.setLesson.bind(this)}
          key={item.id} lesson={item}/>)
        })}
        </div>)
    } else if (!this.state.done) {
      return (<Article done={() => {this.setState({done:true})}}
      lesson={this.state.lesson}/>)
    } else {
      return (
        <div>
        <ArabToLatinModule practiceDone={this.practiceDone.bind(this)}
        lesson={this.state.lesson}
        form={this.state.lesson.form} set={this.state.lesson.set}/>
        </div>
      )
    }
  }

  practiceDone() {
    if (this.state.lesson.allFormsDone()) {

    }
    this.setState({lesson: null, done: false})
  }

}

class LessonButton extends React.Component {
  sendDataToParent() {
    this.props.setLesson(this.props.lesson)
  }
  render() {
    return (<div className="LessonButtonBox"
    onClick={this.sendDataToParent.bind(this)}>{this.props.lesson.name}</div>)
  }
}

export default LessonIndex
